export const PaymentMethodTypes = {
  DEBIT: 'debit',
  CREDIT: 'credit',
  APPLE: 'apple',
  GOOGLE: 'google',
  PRIORITY_WITHDRAW: 'priority_withdraw',
  VENMO: 'venmo',
} as const;

export type PaymentMethodType =
  (typeof PaymentMethodTypes)[keyof typeof PaymentMethodTypes];

export type FeeType =
  (typeof PaymentMethodTypes)[keyof typeof PaymentMethodTypes];

export const MaxAmountTypes = {
  CHECKOUT: 'checkout_amount',
  ACH: 'ach_amount',
  ACH_WITHDRAW: 'ach_withdraw_amount',
};

export type MaxAmountType =
  (typeof MaxAmountTypes)[keyof typeof MaxAmountTypes];

export const PaymentLinkV2Types = {
  CAMPAIGN: 'CAMPAIGN',
  SAVING_GOAL: 'SAVING_GOAL',
} as const;

export const DestinationAccountTypes = {
  CHECKING: 'checking',
  SAVINGS: 'savings',
} as const;

export type TDestinationAccountType =
  (typeof DestinationAccountTypes)[keyof typeof DestinationAccountTypes];

export type TPaymentLinkV2Type =
  | (typeof PaymentLinkV2Types)[keyof typeof PaymentLinkV2Types]
  | (string & {});

export enum CampaignType {
  GIFT = 'gift',
  CLASSROOM = 'classroom',
  COMMUNITY = 'community',
  YOUTH_ACTIVITIES = 'youth_activities',
  NEIGHBORHOOD = 'neighborhood',
}

export const CAMPAIGN_TYPE_LABELS: Record<CampaignType, string> = {
  [CampaignType.GIFT]: 'School staff gift',
  [CampaignType.CLASSROOM]: 'Classroom drive',
  [CampaignType.COMMUNITY]: 'Community initiative',
  [CampaignType.YOUTH_ACTIVITIES]: 'Youth activities',
  [CampaignType.NEIGHBORHOOD]: 'Neighbor support',
};
